module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - Road to Enlightenment (load_3).00af5c5e.txt";